var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "py-6" }, [
    _c("h3", { staticClass: "text-lg font-medium mb-4" }, [
      _vm._v("Step 2 of 9: Emergency Contact"),
    ]),
    _c(
      "div",
      { staticClass: "grid grid-cols-2 gap-3" },
      [
        _c("ValidationProvider", {
          attrs: { name: "Name", rules: "required" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _c("span", { staticClass: "required-icon" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v(" Name"),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "emergency_contact_name",
                          placeholder: "Enter name",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("emergency_contact_name", val),
                        },
                        model: {
                          value: _vm.formData.emergency_contact_name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "emergency_contact_name",
                              $$v
                            )
                          },
                          expression: "formData.emergency_contact_name",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Relationship" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Relationship "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          getParentCustom: "clientWidth",
                          name: "emergency_relationship",
                          placeholder: "Select relationship",
                          inputClass: "w-full",
                          options: [
                            { label: "Family", value: "Family" },
                            { label: "Friend", value: "Friend" },
                            { label: "Neighbor", value: "Neighbor" },
                            { label: "Other", value: "Other" },
                          ],
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("emergency_relationship", val),
                        },
                        model: {
                          value: _vm.formData.emergency_relationship,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "emergency_relationship",
                              $$v
                            )
                          },
                          expression: "formData.emergency_relationship",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Phone Number", rules: "required|phone" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _c("span", { staticClass: "required-icon" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v(" Phone Number "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(Administrative use only)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("StandardizedPhoneInput", {
                        attrs: {
                          invalid: !!errors.length,
                          "error-message": errors[0],
                          placeholder: "(123) 456-7890",
                          size: "md",
                          variant: "outline",
                          "custom-class": "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("emergency_phone_number", val),
                          validation: _vm.handlePhoneValidation,
                        },
                        model: {
                          value: _vm.formData.emergency_phone_number,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "emergency_phone_number",
                              $$v
                            )
                          },
                          expression: "formData.emergency_phone_number",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Email", rules: "required" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _c("span", { staticClass: "required-icon" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v(" Email "),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "emergency_email",
                          placeholder: "Enter email",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("emergency_email", val),
                        },
                        model: {
                          value: _vm.formData.emergency_email,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "emergency_email", $$v)
                          },
                          expression: "formData.emergency_email",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          staticClass: "col-span-2",
          attrs: { name: "Additional Notes" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Additional Notes "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormTextarea", {
                        attrs: {
                          customBorderClass: "borderTen",
                          name: "emergency_additional_notes",
                          placeholder: "Type here",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("emergency_additional_notes", val),
                        },
                        model: {
                          value: _vm.formData.emergency_additional_notes,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "emergency_additional_notes",
                              $$v
                            )
                          },
                          expression: "formData.emergency_additional_notes",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }